/** @format */

export const dummyWidget = [
  {
    i: '1',
    type: 'extranet',
    size: 'normal',
    title: 'Extranet',
    data: [
      {
        id: 1,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 2,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 3,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 4,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 5,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 6,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      }
    ]
  },
  {
    i: '2',
    type: 'extranet',
    size: 'medium',
    title: 'Extranet',
    data: [
      {
        id: 1,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 2,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 3,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 4,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 5,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 6,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      }
    ]
  },
  {
    i: '22',
    type: 'extranet',
    size: 'medium',
    title: 'Extranet',
    data: []
  },
  {
    i: '3',
    type: 'extranet',
    size: 'large',
    title: 'Extranet',
    data: [
      {
        id: 1,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 2,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 3,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 4,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 5,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 6,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      }
    ]
  },
  {
    i: '4',
    type: 'extranet',
    size: 'wide',
    title: 'Extranet',
    data: [
      {
        id: 1,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 2,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 3,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 4,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 5,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 6,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      }
    ]
  },
  {
    i: '5',
    type: 'extranet',
    size: 'xwide',
    title: 'Extranet',
    data: [
      {
        id: 1,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 2,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 3,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 4,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 5,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 6,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      }
    ]
  },
  {
    i: '6',
    type: 'extranet',
    size: '2xl',
    title: 'Extranet',
    data: [
      {
        id: 1,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 2,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 3,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 4,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 5,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 6,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        tags: ['Sales Information', 'Tag topic', 'Actuators and valves', 'Mibility Package', 'Test', 'Valles'],
        languages: ['EN', 'DE', 'FR', 'IT'],
        text: 'Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amit, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      }
    ]
  }
];
